import Vue from "vue";
import Router from "vue-router";

import routes from "./routes";
import store from "@/store";
import PersonService from "@/services/PersonService";
import PaymentService from "@/services/PaymentService";
import OrderService from "@/services/OrderService";

Vue.use(Router);

const router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    else return { x: 0, y: 0 };
  },
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  mode: "history",
  base: process.env.BASE_ENV
});

router.beforeEach(async (to, from, next) => {
  const linkToken = to.query.chargeToken;
  if (linkToken) {
    if (store.getters.getChargeToken !== linkToken) {
      store.dispatch("$setCurrentCharge", {});
      store.dispatch("$setCurrentOrder", null);
      store.dispatch("$setIsValidated", false);
    }
    store.dispatch("$setChargeToken", linkToken);
  }
  if (to.meta.requiresAuth) {
    const personService = new PersonService();
    if (personService.isAuthenticated()) {
      const token = store.getters.getChargeToken;

      if (token != null && store.getters.getCurrentOrder == null) {
        try {
          const orderService = new OrderService();
          const charge = await orderService.getChargeByToken(token);
          if (charge) {
            await new PaymentService().updatePersonCharge(
              personService.getPersonId(),
              token
            );
            store.dispatch(
              "$setCurrentOrder",
              await orderService.getOrderById(charge.order.id)
            );
          }
        } catch (err) {
          console.error(err);
        }
      }

      next();
    } else {
      next("auth");
    }
  } else {
    next();
  }
});

export default router;
